<template>
  <alert type="alert-color" icon="warning" v-if="$store.state.user.scope.has_engaged_preference === false" align="top">
    <div slot="content">
      {{$t('message.labelHi')}} {{$store.state.user.scope.firstname}}, {{$t('message.labelUpdateCommPreferences')}}
      <br/>
      <router-link
        :to="{name: 'SettingsPreferences'}"
        slot="action"
        class="pointer"
        v-text="$t('message.updateText')"
      ></router-link>
    </div>
  </alert>
</template>
<script>
  import Alert from "../Alert/Alert";
  export default {
    components: {Alert},
    name: "gdpr-reminder"
  }
</script>



// WEBPACK FOOTER //
// gdpr-reminder.vue?c31ab4b8